import { useState, useEffect } from "react";
import {Card,Button,Row,Col,Space,App,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./Item.scss";
import { sendBillAction } from "../../../components/action/SendBillAction";
import CustomizeOrder from "../../../components/customizeorder/CustomizeOrder";

import { useProductStore } from "../../../store/Products";


const CoffeeMenu = ({ coffeeItems }) => {
  const [selectedSizes, setSelectedSizes] = useState({}); 
  const [isToppingModalOpen, setIsToppingModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const { message } = App.useApp();

  const { products, fetchProducts, loading } = useProductStore();

  // Fetch products on mount
  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const [note, setNote] = useState("");
  const [size, setSize] = useState("M");
  const [sugar, setSugar] = useState("100%");
  const [ice, setIce] = useState("100%");
  const [selectedToppings, setSelectedToppings] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");



  const toppingItems = (products || []).filter((item) => item.type === "Topping");

  const handleSizeSelect = (itemId, newSize) => {
    setSelectedSizes((prev) => ({
      ...prev,
      [itemId]: newSize,
    }));
  };


  const handleOpenTopping = (item) => {
    setCurrentItem(item);
    setSize(selectedSizes[item.name] || "M");
    setSugar("100%");
    setIce("100%");
    setNote("");
    setSelectedToppings([]);
    setSearchTerm("");
    setIsToppingModalOpen(true);
  };



  const handleConfirm = () => {
    if (!currentItem) return;
    const toppingsPayload = selectedToppings.map((t) => ({
      ...t,
      Quantity: t.Quantity ?? 1,
    }));

    sendBillAction(
      "add-item",
      {
        ...currentItem,
        Quantity: 1,
        Size: size,
        Sugar: sugar,
        Ice: ice,
        Note: note,
        Toppings: toppingsPayload,
      },
      selectedSizes,
      message
    );
    setIsToppingModalOpen(false);
  };

  // quick add (without customization)
  const handleQuickAdd = (item) => {

    sendBillAction(
      "add-item",
      {
        ...item,
        quantity: 1,
        toppings: [],
        note: "",
      },
      selectedSizes,
      message,
    );
  };

  return (
    <div className="coffee-menu">
      <Row gutter={[16, 16]}>
        {coffeeItems.map((item, index) => {
          const selectedSize = selectedSizes[item.name];

          return (
            <Col xs={24} sm={12} md={8} lg={6} key={item.id ?? index}>
              <Card className="coffee-card" cover={<img alt={item.name} src={item.img} />}>
                <div className="frame-item-infor-add-button">
                  <div className="coffee-info">
                    <h3 className="coffee-name">{item.name}</h3>
                    <p className="coffee-price">${item.price.toFixed(2)}</p>
                  </div>

                  <Button
                    type="primary"
                    shape="circle"
                    icon={<PlusOutlined />}
                    className="add-btn"
                    onClick={() => handleQuickAdd(item)}
                  />
                </div>

                {/* Actions */}
                {item.type !== "Topping" && (
                  <div className="options-container">
                    <Button
                      className="topping-btn"
                      style={{
                        border: "1.5px solid #909cf5",
                        color: "#909cf5",
                        borderRadius: "10px",
                      }}
                      onClick={() => handleOpenTopping(item)}
                    >
                      Customize
                    </Button>

                    <Space className="size-options">
                      {["S", "M", "L"].map((s) => (
                        <Button
                          key={s}
                          className={`size-btn ${selectedSize === s ? "active" : ""}`}
                          onClick={() => handleSizeSelect(item.name, s)}
                        >
                          {s}
                        </Button>
                      ))}
                    </Space>
                  </div>
                )}
              </Card>
            </Col>
          );
        })}
      </Row>

      {/* Customization Modal */}
      <CustomizeOrder
        open={isToppingModalOpen}
        setOpen={setIsToppingModalOpen}
        item={currentItem}
        editMode={false}
        toppings={toppingItems}
        selectedToppings={selectedToppings}
        setSelectedToppings={setSelectedToppings}
        size={size}
        setSize={setSize}
        sugar={sugar}
        setSugar={setSugar}
        ice={ice}
        setIce={setIce}
        note={note}
        setNote={setNote}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        onConfirm={handleConfirm}
        onCancel={() => setIsToppingModalOpen(false)}
      />
    </div>
  );
};

export default CoffeeMenu;
